import { CmsComponentTypeEnum } from '@models/enums';
import { BaseComponentConfig } from './base-config';
import { LinkObject } from '@models/interfaces';

export namespace Widget {
  export const TypeEnum = CmsComponentTypeEnum.WIDGET;

  export interface ComponentConfig extends BaseComponentConfig {
    enabled: boolean;
    link?: LinkObject;
  }
}
